"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _Field = _interopRequireDefault(require("../Field"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * The props for the Textarea component.
 */

/**
 * This is a [React](https://reactjs.org/) component for the Vanilla [Textarea](https://docs.vanillaframework.io/base/forms/#textarea).
 *
 * The Textarea component defines a multi-line text input control.
 */
const Textarea = _ref => {
  var _props$value;
  let {
    caution,
    className,
    error,
    grow = false,
    help,
    id,
    label,
    labelClassName,
    onKeyUp,
    onControlEnter,
    required,
    stacked,
    style,
    success,
    takeFocus = false,
    wrapperClassName,
    ...props
  } = _ref;
  const textareaRef = (0, _react.useRef)(null);
  const validationId = (0, _react.useId)();
  const helpId = (0, _react.useId)();
  const hasError = !!error;
  const [innerValue, setInnervalue] = (0, _react.useState)(props.defaultValue);
  const defaultTextAreaId = (0, _react.useId)();
  const textAreaId = id || defaultTextAreaId;
  const handleKeyDown = (0, _react.useCallback)(event => {
    if (event.key === "Enter" && (event.ctrlKey || event.metaKey) && document.activeElement === textareaRef.current) {
      onControlEnter();
    }
  }, [onControlEnter]);
  (0, _react.useEffect)(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);
  (0, _react.useEffect)(() => {
    if (takeFocus) {
      textareaRef.current.focus();
    }
  }, [takeFocus]);
  (0, _react.useLayoutEffect)(() => {
    if (grow) {
      const textArea = textareaRef.current;
      if (textArea) {
        textArea.style.height = "0px";
        const scrollHeight = textArea.scrollHeight;
        textArea.style.height = "".concat(scrollHeight, "px");
      }
    }
  }, [textareaRef, grow, innerValue, props.value]);
  return /*#__PURE__*/_react.default.createElement(_Field.default, {
    caution: caution,
    className: wrapperClassName,
    error: error,
    forId: textAreaId,
    help: help,
    helpId: helpId,
    label: label,
    labelClassName: labelClassName,
    required: required,
    stacked: stacked,
    success: success,
    validationId: validationId
  }, /*#__PURE__*/_react.default.createElement("textarea", _extends({
    "aria-describedby": [help ? helpId : null, success ? validationId : null].filter(Boolean).join(" "),
    "aria-errormessage": hasError ? validationId : null,
    "aria-invalid": hasError,
    className: (0, _classnames.default)("p-form-validation__input", className),
    id: textAreaId,
    onKeyUp: evt => {
      onKeyUp && onKeyUp(evt);
    },
    onChange: evt => {
      if (!props.value) {
        setInnervalue(evt.target.value);
      }
    },
    ref: textareaRef,
    style: grow && {
      minHeight: "5rem",
      resize: "none",
      overflow: "hidden",
      boxSizing: "border-box",
      ...style
    } || style
  }, props, {
    value: (_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : innerValue
  })));
};
var _default = exports.default = Textarea;